module.exports = __webpack_public_path__ + "img/8e613e8.jpg";